import styled from 'styled-components'

export const DocumentsUploadContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
